module.exports = __webpack_public_path__ + "img/plate-g.cf66afd6.svg";